import { render, staticRenderFns } from "./studyInfo.vue?vue&type=template&id=3b86afbc&"
import script from "./studyInfo.vue?vue&type=script&lang=js&"
export * from "./studyInfo.vue?vue&type=script&lang=js&"
import style0 from "./studyInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports